import { isNil } from 'lodash'
import { useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useVerifyRecaptchaMutation } from 'store/api/yay/recaptcha'
import { removeError, selectRecaptchaErrors } from 'store/slices/recaptcha'

import ReCaptcha from './ReCaptcha'

const GlobalReCaptcha = () => {
  const isVerifying = useRef(false)
  const reCaptcha = useRef(null)
  const errorListRef = useRef([])
  const dispatch = useDispatch()
  const errorList = useSelector(selectRecaptchaErrors)
  const [verifyRecaptcha] = useVerifyRecaptchaMutation({
    fixedCacheKey: 'single',
  })

  const onVerifyReCaptcha = async (token) => {
    const verifyRecaptchaRes = await verifyRecaptcha(token)

    errorListRef.current.map((action) => {
      if (
        verifyRecaptchaRes?.['data']?.result === 'success' &&
        !isNil(action.type)
      ) {
        dispatch(action)
      }

      dispatch(removeError(action.id))
    })
  }

  const showReCaptcha = () => {
    isVerifying.current = true
    reCaptcha.current.reset()
    reCaptcha.current.execute()
  }

  useEffect(() => {
    if (!isVerifying.current && errorList.length !== 0) {
      showReCaptcha()
    } else if (errorList.length === 0) {
      isVerifying.current = false
    }

    // we need to assign error list to ref
    // to make new errorList update in grecaptcha callback closure
    errorListRef.current = errorList
  }, [errorList])

  return (
    <ReCaptcha
      ref={(el) => (reCaptcha.current = el)}
      size="invisible"
      render="explicit"
      onSuccess={onVerifyReCaptcha}
    />
  )
}

export default GlobalReCaptcha
